<template>
  <div class="iosbuy">
    <p class="title">自动续费协议</p>
    <div class="block">
      <p class="common-p">
        欢迎您使用自动续费会员服务！<br/><br/>
        本协议是您为使用广州心与潮信息科技有限公司（简称：心潮科技）小睡眠自动续费服务，您应当阅读并遵守《自动续费服务条款》（以下简称“本条款”）。<br/><br/>
        本条款为《服务协议》、《隐私政策》和《会员服务协议》的特别服务条款。请在接受使用会员订阅服务前务必审慎阅读、充分理解《服务协议》、《隐私政策》、《会员服务协议》及本条款的相应内容，并选择接受或不接受。本条款未予以约定的，适用《服务协议》、《隐私政策》、《会员服务协议》的约定；本条款与《服务协议》、《隐私政策》、《会员服务协议》有冲突的，以本条款为准。<br/><br/>
      </p>
      <p class="two-title">一、自动续费服务的内容</p>
      <p class="common-p">
        1. 连续包月（包季、包年）是在您已开启会员订阅服务的前提下，向您提供的自动续费服务。如您开通自动续费服务，则视为您授权小睡眠在您已开通的会员订阅服务即将到期时，从您的自有充值账户、与小睡眠帐号绑定的第三方支付账户、银行卡、通讯账号、iTunes账户（简称“账户”）等，代扣下一个计费周期的月卡（季卡、年卡）服务费用。扣费时间为计费周期到期前24小时内。<br/><br/>
        2. 您需要将小睡眠帐号与前述账户进行绑定，且保证有足够余额支持代扣。因上述账户余额不足导致续费失败的，您将自行承担相应结果。<br/><br/>
        3. 您可通过下述途径取消已开通的自动续费服务：<br/><br/>
        （1）苹果手机在 iOS设备“设置” → “iTunes Store 与 App Store” → 选择“Apple ID” → 点击“查看 Apple ID” → 在账户设置页面点击“订阅” → 取消订阅。如未在计费周期到期前至少24小时前取消自动续费功能，将会自动续订及扣款。<br/><br/>
        4.自动续费服务与正常会员服务并存说明<br/><br/>
        当连续包月（包季、包年）会员与正常会员服务出现并存情况时，则优先使用连续包月（包季、包年）会员时长， 正常会员服务时长则在原服务有效期基础上延长。<br/><br/>
      </p>
      <p class="two-title">二、付费服务</p>
      <p class="common-p">
        （一）您理解并同意，自动续费服务为付费服务，小睡眠将收取互联网增值服务使用费；您可以在相关服务页面查阅自动续费服务具体期限及对应费用并自行选择服务的种类。开启自动续费功能后，无论您是否在相应服务期限内实际使用该服务，已支付的费用不支持退款。<br/><br/>
        （二）您理解并同意，心潮科技有权自行决定并不时修订自动续费服务相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本条款的有效组成部分。如您不同意前述标准、规则及其修订，您有权停止使用自动续费服务。您继续使用自动续费服务即视为您同意相关内容。<br/><br/>
      </p>
      <p class="two-title">
        三、免责声明
      </p>
      <p class="common-p">
        心潮科技有权根据产品计划和运营情况独立决定自动续费服务的具体内容，并有权根据内容的版权情况新增或移除内容或暂停、终止提供自动续费服务的部分功能服务。前述决定不经通知即生效，您同意心潮科技对此免责。<br/><br/>
        如您对上述条款有任何疑问请发送电子邮件到office@heartide.com。<br/><br/>
      </p>
    </div>

    <div class="block">
      <p class="two-title" style="text-align: right">广州心与潮信息科技有限公司</p>
      <p class="common-p" style="text-align: right">更新时间2020年11月30日</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iosbuy',
  mounted () {
    document.title = '自动续费协议'
  }
}
</script>

<style lang="scss" scoped>
.iosbuy {

  p {

    font-size: 16px;
  }
  font-size: px2html(14px);
  box-sizing: border-box;
  margin-top: px2html(20px);
  padding-left: px2html(21px);
  padding-right: px2html(21px);
  .title {
    font-size: px2html(16px);
    font-weight: 900;
    margin-bottom: px2html(28px);
  }
  .block {
    margin-bottom: px2html(28px);
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: px2html(14px);
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }
}
</style>
